import { render } from "./ListaMuzee.vue?vue&type=template&id=50a8cd7e"
import script from "./ListaMuzee.vue?vue&type=script&lang=js"
export * from "./ListaMuzee.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__